import { TEAM_LOGOS } from './teams';

// Hockey India League 2026 league table (after the league stage).
const table = [
  {
    pos: 1,
    team: 'Vedanta Kalinga Lancers',
    p: 7,
    w: 4,
    ws: 2,
    l: 1,
    ls: 0,
    gf: 16,
    ga: 8,
    gd: 8,
    pts: 16,
    form: ['W', 'W', 'L', 'W', 'W'],
  },
  {
    pos: 2,
    team: 'Ranchi Royals',
    p: 7,
    w: 3,
    ws: 1,
    l: 2,
    ls: 1,
    gf: 25,
    ga: 18,
    gd: 7,
    pts: 12,
    form: ['W', 'L', 'L', 'W', 'L'],
  },
  {
    pos: 3,
    team: 'Hyderabad Toofans',
    p: 7,
    w: 3,
    ws: 0,
    l: 2,
    ls: 2,
    gf: 17,
    ga: 11,
    gd: 6,
    pts: 11,
    form: ['W', 'W', 'W', 'L', 'W'],
  },
  {
    pos: 4,
    team: 'HIL GC',
    p: 7,
    w: 3,
    ws: 0,
    l: 2,
    ls: 2,
    gf: 21,
    ga: 18,
    gd: 3,
    pts: 11,
    form: ['L', 'L', 'L', 'L', 'L'],
  },
  {
    pos: 5,
    team: 'JSW Soorma Hockey Club',
    p: 7,
    w: 3,
    ws: 1,
    l: 3,
    ls: 0,
    gf: 16,
    ga: 14,
    gd: 2,
    pts: 11,
    form: ['W', 'W', 'L', 'W', 'W'],
  },
  {
    pos: 6,
    team: 'Accord Tamil Nadu Dragons',
    p: 7,
    w: 1,
    ws: 3,
    l: 2,
    ls: 1,
    gf: 19,
    ga: 22,
    gd: -3,
    pts: 10,
    form: ['W', 'L', 'L', 'L', 'W'],
  },
  {
    pos: 7,
    team: 'Shrachi Bengal Tigers',
    p: 7,
    w: 3,
    ws: 0,
    l: 4,
    ls: 0,
    gf: 16,
    ga: 24,
    gd: -8,
    pts: 9,
    form: ['L', 'L', 'W', 'L', 'W'],
  },
  {
    pos: 8,
    team: 'SG Pipers',
    p: 7,
    w: 1,
    ws: 0,
    l: 5,
    ls: 1,
    gf: 14,
    ga: 29,
    gd: -15,
    pts: 4,
    form: ['W', 'L', 'L', 'L', 'L'],
  },
];

export const standings = table.map((row) => ({ ...row, logo: TEAM_LOGOS[row.team] }));
